<template>
  <!-- <div class="dashboard__timesaving">
    <div class="p-5 d-flex justify-content-center align-items-center"
      v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="25"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else class="dashboard__timesaving--content">
      <div class="fontstyle__title--sectionblue">{{ datas.header }}</div>
      <div class="content__body">
        <div v-if="datas.body.type === DISPLAY_TIME_PERFORMANCE">
          <div class="content__body--time">
            <h3>{{ datas.body.item }}%</h3>
            <p>On Time</p>
          </div>
          <DoughnutChart
            :chart-data="chartData"
            :options="options"
            :width=120
            :height=120>
          </DoughnutChart>
        </div>
        <div v-if="datas.body.type === DISPLAY_SAVINGS">
          <div class="content__body--saving">{{ datas.body.item }}%</div>
        </div>
      </div>
      <div class="content__footer">
        <p class="fontstyle__defaultdashboard--blue">{{ this.getFooterText(datas) }}</p>
      </div>
    </div>
  </div> -->
  <div class="dashboard__timesaving" :style="datas.body.type === DISPLAY_SAVINGS ? 'margin-top: 20px;' : 'height: 531px;'">
    <div class="p-5 d-flex justify-content-center align-items-center"
      v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="25"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else >
      <div class="dashboard__timesaving--title" style="border-bottom: 1px solid #E8EBEE; padding: 19px 0px;">
        <p class="ml-2">{{ datas.header }}</p>
      </div>
      <div class="dashboard__timesaving--content">
        <div class="content__body">
        <div v-if="datas.body.type === DISPLAY_TIME_PERFORMANCE">
          <div class="content__body--time mt-2">
            <p style="font-weight: bold; font-size: 24px; color: #1D3354; ">{{ datas.body.item }}</p>
            <p>Shipment</p>
          </div>
          <div class="mt-4">
            <DoughnutChart
            :chart-data="chartData"
            :options="options"
            :width=120
            :height=120
            :weight=100
            >
            </DoughnutChart>
          </div>
          <div class="mt-5">
            <div class="d-flex justify-content-center align-items-center">
            <div style="height: 10px;
            width: 15px;
            background-color: #1D3354;"></div>
            <div class="col-4 ml-2">On time</div>
            <div class="ml-4">: {{ datas.body.ontime ? datas.body.ontime+'%' : '-'}}</div>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <div style="height: 10px;
            width: 15px;
            background-color: #C4232A;"></div>
            <div class="col-4 ml-2">In Progress</div>
            <div class="ml-4">: {{ datas.body.inprogress ? datas.body.inprogress+'%' : '-' }}</div>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <div style="height: 10px;
            width: 15px;
            background-color: #FD9E00;"></div>
            <div class="col-4 ml-2">Delay</div>
            <div class="ml-4">: {{ datas.body.delay ? datas.body.delay+'%' : '-'}}</div>
          </div>
          </div>
        </div>
        <div v-if="datas.body.type === DISPLAY_SAVINGS">
          <div class="content__body--saving">{{ datas.body.item ? datas.body.item+'%' : '-'}}</div>
        </div>
      </div>
      <div v-if="datas.body.type === DISPLAY_SAVINGS" :class="datas.body.type === DISPLAY_SAVINGS ? 'content__footer' : 'content__footer mt-5'">
        <p class="fontstyle__defaultdashboard--blue">{{ this.getFooterText(datas) }}</p>
      </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { DISPLAY_TIME_PERFORMANCE, DISPLAY_SAVINGS } from '@/constant/page/dashboard'
import DoughnutChart from '@/components/dashboard/chart/DoughnutChart.vue'
import _ from 'lodash'

const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    animateRotate: true,
    animateScale: true
  },
  cutoutPercentage: 80,
  events: []
}

export default {
  name: 'TimeAndSaving',
  components: {
    DoughnutChart,
    HalfCircleSpinner
  },
  props: {
    datas: Object,
    isLoading: Boolean
  },
  data () {
    return {
      DISPLAY_TIME_PERFORMANCE,
      DISPLAY_SAVINGS,
      options,
      chartData: {}
    }
  },
  computed: {
  },
  mounted: function () {
  },
  methods: {
    getFooterText (currentData) {
      if (currentData) {
        if (currentData.body.type === DISPLAY_TIME_PERFORMANCE) {
          return `Andalin has succesfully delivered 
                  ${currentData.body.item}% of your shipments on time! 
                  Let’s ship more!`
        } else if (currentData.body.type === DISPLAY_SAVINGS) {
          if (!currentData.body.item) {
            return `Ship with Andalin and save more!`
          } else {
            return `You have saved $${currentData.body.item} for your most frequent 
                  shipments compared to your collective ideal budget range.`
          }
        }
      }
      return ''
    },
    getDataSets () {
      return new Promise((resolve) => {
        if (this.datas && this.datas.body.type === DISPLAY_TIME_PERFORMANCE) {
          if (!this.datas.body.ontime && !this.datas.body.delay && !this.datas.body.inprogress) {
            this.chartData = {
              datasets: [
                {
                  backgroundColor: ['#DCDCDC'],
                  data: [100]
                  
                }
              ]
            }
            this.options = {
              legend: {
                display: false
              },
              responsive: true,
              maintainAspectRatio: false,
              cutoutPercentage: 70,
              tooltips: false
            }
          } else {
            this.chartData = {
              labels: [`On Time : ${this.datas.body.ontime}%`, `delay : ${this.datas.body.delay}`, `in progress : ${this.datas.body.inprogress}`],
              datasets: [
                {
                  backgroundColor: ['#1D3354', '#FD9E00', '#C4232A'],
                  // eslint-disable-next-line standard/array-bracket-even-spacing
                  data: [this.datas.body.ontime, this.datas.body.delay, this.datas.body.inprogress ]
                }
              ]
            }
            this.options = {
              legend: {
                display: false
              },
              responsive: true,
              maintainAspectRatio: false,
              cutoutPercentage: 70
            }
          }
        }
        return resolve()
      })
    },
    getDiff (data) {
      return 100 - data
    }
  },
  watch: {
    async isLoading (data) {
      if (!_.isNil(data) && !_.isNil(this.datas)) {
        await this.getDataSets()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/TimeAndSaving.vue